<template>
  <div class="min-h-screen flex-1 mt-1 bg-gray-100 px-4 py-3 items-center">
    <div class="bg-white w-full rounded-lg shadow pb-20">
      <div class="h-20 py-3 flex items-center border-gray-200 p-6 mt-5">
        <div class="flex w-full">
          <button
            :class="$colors.primary"
            class="rounded-full flex justify-center items-center w-8 h-8 mr-3"
            @click="RouterBack()"
          >
            <i class="material-icons">chevron_left</i>
          </button>
           <div class="text-xl font-bold text-blue-600">Refund details</div>
        </div>
      </div>
      <!-- **********Shipping info*********** -->
                 <div class="flex bg-white w-full space-x-2">
                        <div class="flex w-full justify-between shadow-xs items-center h-auto p-6 my-1 mb-1 rounded-lg">
                            <div class="flex w-full mt-1">
                                <span class="rounded-full h-12 w-12 bg-gray-200">
                                    <i class="material-icons p-3 text-blue-400">person</i>
                                </span>

                                <div class="ml-5 w-full pb-4">
                                    <div class="text-base mt-1 font-semibold text-gray-600 pb-10">
                                        Order information
                                    </div>
                                    <div class="text-sm font-light text-gray-500"></div>
                                    <div class="tab-content">
                                      <div id="latest-tasks-new" class="tab-pane active">
                                          <div class="flex items-center">
                                              <div class="border-l-2 border-blue-600 dark:border-blue-500 pl-4">
                                                 <span  class="font-medium">Order #</span>
                                                 <div class="text-gray-600">{{ $f.getIdbySplit(formData.ObjetDetails.orderId)}}</div>
                                               </div>
                                          </div>
                                           <div v-if="formData.ObjetDetails.customer" class="flex items-center mt-5">
                                              <div class="border-l-2 border-blue-600 dark:border-blue-500 pl-4">
                                                 <span  class="font-medium">Customer </span>
                                                 <div class="text-gray-600"><i class="material-icons tiny">contacts</i> {{ formData.ObjetDetails.customer.fullName}}</div>
                                                 <div class="text-gray-600"><i class="material-icons tiny">local_phone</i> {{ formData.ObjetDetails.customer.phone}}</div>
                                               </div>
                                          </div>
                                           <div class="flex items-center mt-5">
                                              <div class="border-l-2 border-blue-600 dark:border-blue-500 pl-4">
                                                 <span  class="font-medium">Seller </span>
                                                 <div class="text-gray-600">{{ formData.ObjetDetails.fullName}}</div>
                                               </div>
                                          </div>
                                          <div class="flex items-center mt-5">
                                            <div class="border-l-2 border-blue-600 dark:border-blue-500 pl-4">
                                              <span  class="font-medium">Refund</span>
                                              <div class="text-gray-600">{{formData.ObjetDetails.totalPrice}}</div>
                                            </div>
                                          </div>
                                      </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                          <!-- ****************************** Order Information *********************************************-->

                    <div class="flex w-full justify-between shadow-xs items-center h-auto p-6 my-1 mb-1 rounded-lg">
                        <div class="flex w-full mt-1">
                            <span class="rounded-full h-12 w-12 bg-gray-200">
                                <i class="material-icons p-3 text-blue-400">local_grocery_store</i>
                            </span>

                            <div class="ml-5 w-full pb-4">
                                    <div class="text-base mt-1 font-semibold text-gray-600 pb-10">
                                        Refund information
                                    </div>
                                    <div class="text-sm font-light text-gray-500"></div>
                                    <div class="tab-content">
                                      <div id="latest-tasks-new" class="tab-pane active">
                                          <div class="flex items-center">
                                              <div class="border-l-2 border-blue-600 dark:border-blue-500 pl-4">
                                                 <span  class="font-medium">Status </span>
                                                 <div class="text-gray-600">{{ formData.status}}</div>
                                               </div>
                                          </div>
                                           <div class="flex items-center mt-5">
                                              <div class="border-l-2 border-blue-600 dark:border-blue-500 pl-4">
                                                 <span  class="font-medium">Shipping date </span>
                                                 <div class="text-gray-600">{{ $moment(formData.date).format('yyyy-MM-DD')}}</div>
                                               </div>
                                          </div>
                                          <div class="flex items-center mt-5">
                                            <div class="border-l-2 border-blue-600 dark:border-blue-500 pl-4">
                                              <span  class="font-medium">Date accepted</span>
                                              <div class="text-gray-600">{{$moment(formData.acceptedAt).format('yyyy-MM-DD HH:mm') }} </div>
                                            </div>
                                          </div>
                                      </div>
                                    </div>
                                </div>
                        </div>
                    </div>
                  </div>
                    <!--*******************  Product Order ***************************************-->
                    <div class="flex w-full justify-between shadow-xs items-center h-auto p-6 my-1 mb-1 rounded-lg">
                        <div class="flex w-full mt-1">
                            <span class="rounded-full h-12 w-12 bg-gray-200">
                                <i class="material-icons p-3 text-blue-400">local_mall</i>
                            </span>

                            <div class="ml-5 w-full pb-4">
                                <div class="text-base mt-1 font-semibold text-gray-600 pb-10">
                                    Order Products
                                </div>

                                <div class="w-full space-y-4">
                                    <div class="w-full">
                                        <table style="display: inline-table;"
                                            class="w-full flex flex-row flex-no-wrap sm:bg-white rounded-md overflow-hidden sm:shadow-xs">
                                            <thead class="text-white">
                                                <tr
                                                    class="bg-blue-400 flex flex-col flex-no wrap sm:table-row rounded-l-lg sm:rounded-none mb-2 sm:mb-0">
                                                    <th class="p-2 justify-center">Products</th>
                                                    <th class="p-2 justify-center">Quantity</th>
                                                    <th class="p-2 justify-center">Total</th>
                                                </tr>
                                            </thead>
                                            <tbody class="flex-1 sm:flex-none" v-for="it in formData.ObjetDetails.products" :key="it._id">
                                                <tr class="flex flex-col flex-no wrap sm:table-row mb-2 sm:mb-0">
                                                    <td
                                                        class="border-grey-light text-xs justify-center border hover:bg-gray-100 p-2">
                                                        <div class="flex space-x-10">
                                                            <div>
                                                                <img alt="..."
                                                                    :src="it.image"
                                                                    class="h-16 w-16 rounded-md mx-auto" />
                                                            </div>
                                                            <div>
                                                                {{ it.productName }}
                                                                <p class="font-light">
                                                                    Price : {{ it.unitPrice }} 
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td
                                                        class="border-grey-light text-xs justify-center border hover:bg-gray-100 p-2 truncate">
                                                        {{ it.quantity }}
                                                    </td>
                                                    <td
                                                        class="border-grey-light text-xs justify-center border hover:bg-gray-100 p-2 truncate">
                                                        {{ it.quantity * it.unitPrice }} 
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            <!-- **************/Shipping info****************-->
        <div  class="flex pr-5 pl-5 mt-6">
          <div class="flex justify-between w-full h-auto p-4 rounded-lg border-gray-100" >
            <div class="flex w-full">
              <div class="ml-1 w-full p-2">
                <!--table shipping historie -->
                   <div-table :config="configList" :data="shippingsHistories"  :idWharhouse="idWharhouse" :currentUser="currentUser" :loading="loading" :paginate="paginate"  @paginatation="paginatation"></div-table>
                <!--/ table shipping histories -->
              </div>  
            </div> 
          </div>
        </div>    
    </div>
  </div>
</template>
<script>
import config from './configHistories'
export default {
  props: {
     currentUser: { type: Object},
     idWharhouse: { type: Object}
   },
  data() {
    return {
      configList: config.list,
      loading:false,
       shippingsHistories:[],
       formData: {ObjetDetails:{}},
      show_modal: false,
      content: [],
       paginate: {
        total: 0,
        currentpage: 1,
        lastpage: 1,
        per_page: 0,
       },
    };
  },
  async mounted() {
     if (this.$route.params.id) {
        const editData = await this.$server.get("refunds", {
            id: this.$route.params.id,
        });
        this.formData = editData.content;
         this.formData.date = this.$moment(this.formData.date).format('yyyy-MM-DD');
        this.formData.acceptedAt = this.$moment(this.formData.acceptedAt).format('yyyy-MM-DD HH:mm');
     }
    await this.getShippingHistories();
  },
  methods: {
     RouterBack: function() {
       this.$router.back();
    },
    async getUser() {
      const res = await this.$me;
      this.currentUser = res.content;
    },
    /*******************************************Modal (View) update Chapping address and Status Order ************************************/
    async getShippingHistories() {
      const filter = {
        refund: this.$route.params.id,
      };
      const res = await this.$server.search("refundsHistories", filter);
      if (res.content.results) {
        this.shippingsHistories = res.content.results;
        this.shippingsHistories.total = res.content.total;
        this.shippingsHistories.lastpage = res.content.last_page;
        this.shippingsHistories.per_page = res.content.per_page;
        this.shippingsHistories.currentpage = res.content.current_page;
      } else this.shippingsHistories = [];
    },
    async paginatation(direction){
      var page=0;
      if(direction == "next"){
         page=++this.paginate.currentpage;
      }else{
         page=--this.paginate.currentpage;
      }
       const filters = {
          page: page,
          limit: this.limit,
      };
      this.getShippingHistories(filters);
    },
  },
};
</script>

<style>
/* animation for vue transition tag */
dialog[open] {
  animation: appear 0.15s cubic-bezier(0, 1.8, 1, 1.8);
}
dialog::backdrop {
  background: linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(54, 54, 54, 0.5));
  backdrop-filter: blur(3px);
}
@keyframes appear {
  from {
    opacity: 0;
    transform: translateX(-3rem);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
</style>
